import { HttpInterceptorFn, HttpRequest, HttpHandlerFn, HttpErrorResponse } from '@angular/common/http';
import { inject, NgZone } from '@angular/core';
import { Router } from '@angular/router';
import { catchError, throwError } from 'rxjs';
import { AccessTokenService } from '../services/authentication/access-token.service';
import { CODE_ERRORS, HR_ERRORS } from '../../../common/domain/constants-errors';
import { AUTHENTICATION_URL } from '../../../common/endpoints/endpoints';
import { environment } from '../../../environments/environment';
import { STATES } from '../../../common/domain/states';

export const errorInterceptor: HttpInterceptorFn = (req: HttpRequest<unknown>, next: HttpHandlerFn) => {
  const router = inject(Router);
  const accessToken = inject(AccessTokenService);
  const ngZone = inject(NgZone);

  return next(req).pipe(
    catchError((error: HttpErrorResponse) => {
      _checkRedirectLogin(error, req, router, accessToken, ngZone);
      return throwError(() => error);
    })
  );
};

function _checkRedirectLogin(error: HttpErrorResponse, req: HttpRequest<unknown>, router: Router, accessToken: AccessTokenService, ngZone: NgZone): void {
  const isStatusForbidden = error.status === CODE_ERRORS.FORBIDDEN;
  const isApiUrl = error.url?.includes(environment.apiUrl) ?? false;
  const isNotAuthUrl = error.url !== AUTHENTICATION_URL;
  const hasToRedirectLogin = isStatusForbidden && isApiUrl && isNotAuthUrl;
  const isUnauthorized = error.status === CODE_ERRORS.UNAUTHORIZED;

  if (hasToRedirectLogin || isUnauthorized) {
    const ssoUrl = environment.bbvaSso;
    const currentPath = window.location.pathname;
    localStorage.setItem('path', currentPath);
    ngZone.run(() => {
      window.location.href = `${ssoUrl}${currentPath}`;
    });
    return;
  }

  _checkRedirectError(error, req, router, ngZone);
}

function _checkRedirectError(error: HttpErrorResponse, req: HttpRequest<unknown>, router: Router, ngZone: NgZone): void {
  const skipErrorRedirect = _shouldSkipRedirectByRequest(req);
  if (skipErrorRedirect) {
    return;
  }

  const isHRInternalServerError =
    error.status === CODE_ERRORS.INTERNAL_SERVER_ERROR &&
    error.error?.errors === HR_ERRORS.HR_SERVER_RESPONSE_ERRROR_OFFLINE;
  const isServerDownOrNoInternet = error.status === CODE_ERRORS.SERVER_DOWN_OR_NO_INTERNET;
  const isBackInternalServerError = error.status === CODE_ERRORS.INTERNAL_SERVER_ERROR;

  if (isHRInternalServerError || isServerDownOrNoInternet || isBackInternalServerError) {
    ngZone.run(() => {
      router.navigate([STATES.ERROR]);
    });
  }
}

function _shouldSkipRedirectByRequest(req: HttpRequest<unknown>): boolean {
  const url = req.url || '';
  const isServiceStatusRequest = url.includes('/service-and-payroll-closure-date');
  const isLoansRequest = url.includes('/loans/');
  const isRepaymentRequest = url.includes('/repayment/');
  return isServiceStatusRequest || isLoansRequest || isRepaymentRequest;
}
